"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_81_29_0 = void 0;
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
/**
 * Migrate to 81.29.0
 *
 * Set correct LeitungsdurchmesserMin/LeitungsdurchmesserMax on children of espool.
 */
const migration_81_29_0 = (json) => {
    var _a;
    const espool = json.Espool;
    (_a = json.Children) === null || _a === void 0 ? void 0 : _a.forEach((child) => {
        var _a, _b, _c;
        if (child.Kette &&
            ((_b = echain_shared_quantities_1.Q.optional((_a = child.Kette) === null || _a === void 0 ? void 0 : _a.LeitungsdurchmesserMin)) === null || _b === void 0 ? void 0 : _b.mm) !== ((_c = echain_shared_quantities_1.Q.optional(espool === null || espool === void 0 ? void 0 : espool.LeitungDiameterMax)) === null || _c === void 0 ? void 0 : _c.mm)) {
            child.Kette.LeitungsdurchmesserMin = espool === null || espool === void 0 ? void 0 : espool.LeitungDiameterMax;
        }
    });
    return json;
};
exports.migration_81_29_0 = migration_81_29_0;
//# sourceMappingURL=migration_81_29_0.js.map